module.exports = __webpack_public_path__ + "static/media/B&E.5de948dd.jpg";